import cx from 'classnames';
import React from 'react';

import colors from 'utils/colors';
import * as Styling from 'utils/styled';

import * as Elements from './Elements';
import { IconProps } from './interfaces';

const Close: React.FC<IconProps> = ({
  className = '',
  fill = colors.blueGrey,
  viewBox = '0 0 19.22 19.22',
  d = 'M19.22 1.92L17.3 0 9.61 7.69 1.92 0 0 1.92l7.69 7.69L0 17.3l1.92 1.92 7.69-7.69 7.69 7.69 1.92-1.92-7.69-7.69z',
  transition = 'fill 0.1s ease-in-out',
  cssHelper = Styling.fullWidthStyle,
  focusable
}) => {
  return (
    <Elements.Svg
      className={cx({ [className]: !!className })}
      cssHelper={cssHelper}
      fill={fill}
      transition={transition}
      viewBox={viewBox}
      focusable={!!focusable}
      aria-hidden={!focusable}>
      <Elements.Path d={d} />
    </Elements.Svg>
  );
};

export default Close;
